// Icons:
import { FaCircleCheck } from "react-icons/fa6"

// Typescript:
interface AdvantagesArrPropsType {
    id: number
    title: string
}

const Advantages = () => {
    // Constants:
    const advantagesArr = [
        {
            id: 0,
            title: 'Comprehensive knowledge'
        },
        {
            id: 1,
            title: 'Hands-on experience'
        },
        {
            id: 2,
            title: 'In-demand skills'
        },
        {
            id: 3,
            title: 'Creative Freedom'
        },
        {
            id: 4,
            title: 'Community'
        },
    ]
    return <div className='col-[2_/_3] w-full my-[5rem]'>
        <h2 className='text-[30px] text-center md:text-[40px] font-extrabold mb-[40px]'>Start Learning Today</h2>
        <div className='md:w-[800px] md:mx-[auto] flex flex-wrap gap-[20px] justify-center items-center'>
        {advantagesArr?.map((advantage:AdvantagesArrPropsType)=>
            <div className='w-max flex items-center bg-[#F1F1FF] rounded-[45px] gap-[15px] py-[18px] px-[24px]' key={advantage?.id}>
                <FaCircleCheck size={24} color='#1A9E49'/> 
                <div className='text-[#8F8E8E] font-semibold text-[15px] sm:text-[20px]'>{advantage?.title}</div>
            </div>
        )}
        </div>
    </div>
}

export default Advantages